/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IAnnotationAttr {
  [key: string]: any;
  updatedAt: string;
  updatedBy: any;
}

export class AnnotationAttr implements IAnnotationAttr {
  [key: string]: any;
  updatedAt = new Date().toISOString();
  updatedBy: any;
  constructor(data: any) {
    Object.keys(data).forEach((key: string) => {
      this[key] = data[key];
    });
    this.updatedAt = new Date().toISOString();
    this.updatedBy = data.updatedBy || {};
  }
}

export interface IAnnotationChild {
  className: string;
  // attrs: AnnotationAttr;
  children: any[];
}

export class AnnotationChild implements IAnnotationChild {
  className = '';
  children: any[];
  constructor(data: any) {
    this.className = data.className || '';
    this.children = typeof data.children !== 'undefined' && Array.isArray(data.children) ? data.children.map((r: any) => new AnnotationChildItem(r)) : [];
  }
}

export class AnnotationChildItem {
  attrs: AnnotationAttr;
  className: string;
  id: string;
  constructor(data: any) {
    this.id = data.id || `${new Date().getTime().toString()}_${(1 + Math.floor(Math.random() * 9999)).toString()}`;
    this.attrs = new AnnotationAttr(data.attrs);
    this.className = data.className;
  }
}

export interface IAssetAnnotation {
  id: string;
  assetId: string;
  assetVersionNumber: number;
  className: string;
  comment: string;
}
